export default "__VITE_ASSET__CRimSCMZ__"